/**
 * TanStack Query hooks for `offer18-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	offer18IntegrationQueryKeys,
	type CreateOffer18IntegrationBody,
	type ListOffer18IntegrationResponse,
	type Offer18IntegrationRow,
} from "./api";

export function useOffer18IntegrationList(): UseQueryResult<ListOffer18IntegrationResponse, Error> {
	return useQuery({
		queryKey: offer18IntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useOffer18IntegrationCreate(): UseMutationResult<Offer18IntegrationRow, Error, CreateOffer18IntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: offer18IntegrationQueryKeys.all });
		},
	});
}

export function useOffer18IntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: offer18IntegrationQueryKeys.all });
		},
	});
}
